import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Dimmer,
  Grid,
  Header,
  Loader,
  Menu,
  Modal,
  Segment,
  Table,
} from 'semantic-ui-react';
import qs from 'qs';
import { flashErrorMessage, resetFlashMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';

import SearchFilter from '../../components/SearchFilter';
import PageNav from '../../components/PageNav';
import BankerItem from '../../components/BankerItem';
import LimitCounter from '../../components/LimitCounter';
import HLBEligibleBanner from '../../components/HLBCampaign/HLBEligibleBanner';
import HLBCampaignJoinModal from '../../components/HLBCampaign/HLBCampaignJoinModal';

class BankersList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      companyBranch: PropTypes.object,
    }),
    bankerSelectionTabs: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    bankerOnSelect: PropTypes.func,
    bankerOnCheck: PropTypes.func,
    projectID: PropTypes.string,
    bankID: PropTypes.number,
    limit: PropTypes.number,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    selected: PropTypes.arrayOf(PropTypes.object),
    only: PropTypes.oneOf(['banker', 'preferred_banker', 'panel_banker']),
    extraNode: PropTypes.node,
    bankerOnCheckSelected: PropTypes.func,
    project: PropTypes.shape({
      hlbCampaignIsEnabled: PropTypes.bool,
    }),
    t: PropTypes.func.isRequired,
  }
  static getPropsToState = (props) => {
    const bankerSelectionTabs = props.bankerSelectionTabs;
    const selected = props.selected ? [].concat(props.selected) : [];
    return {
      bankerSelectionTabs,
      selected,
    };
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  constructor(props) {
    super(props);
    const state = BankersList.getPropsToState(props);
    let currentTab = props.only || this.tabs[0].name;
    if (props.only) {
      currentTab = 'banker';
    }
    this.state = {
      ...state,
      data: [],
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      currentTab,
      currentPage: 1,
      query: {},
      search: '',
      customTabs: [],
      showHLBJoinModal: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = BankersList.getPropsToState(nextProps);
    if (nextProps.open === true && this.props.open !== nextProps.open) {
      this.handleOnOpen();
      this.fetchBankers();
      if (this.props.bankerSelectionTabs) {
        this.getCustomTabs();
      }
    }
    this.setState(state);
  }
  setBankers(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getCustomTabs = () => {
    const { t } = this.props;
    const tabs = [];
    if (this.props.bankerSelectionTabs.length > 0) {
      this.props.bankerSelectionTabs.map((tab) => {
        switch (tab) {
          case 'panel_banker':
            return tabs.push({ text: t('Panel', { ns: 'translation' }), name: 'panel_banker', value: 'panel_banker' });
          case 'preferred_banker':
            return tabs.push({ text: t('Preferred', { ns: 'translation' }), name: 'preferred_banker', value: 'preferred_banker' });
          case 'all':
            return tabs.push({ text: t('All', { ns: 'translation' }), name: 'banker', value: 'banker' });
          default:
            break;
        }
        return null;
      });
    }
    this.setState({ customTabs: tabs });
  }
  checkBankerUserIsActive = banker => banker.user.statusID === '100';
  async fetchBankers() {
    await this.setLoading(true);
    await this.setBankers([]);
    const { store } = this.context;
    const query = Object.assign({
      limit: 50,
      page: this.state.currentPage || 1,
      hideSummary: true,
      search: this.state.search || '',
    });
    if (this.state.search) {
      delete query.page;
    }
    if (this.props.bankID) {
      query.bankID = this.props.bankID;
    }
    let url = '/bankers/all/';
    switch (this.state.currentTab) {
      case 'panel_banker':
        if (this.props.projectID) {
          url = `/projects/${this.props.projectID}/bankers/?${qs.stringify(query)}`;
        }
        break;
      case 'preferred_banker':
        url = `/bankers/preferred/?${qs.stringify(query)}`;
        break;
      default:
        url = `/bankers/all/?${qs.stringify(query)}`;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setBankers(data);
      if (this.state.data.length < 1 && query.page > 1) {
        this.setState({ currentPage: 1 }, () => {
          this.fetchBankers();
        });
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
        });
      }
    }
    await this.setLoading(false);
  }
  showHLBCampaign = () => {
    const { project, auth } = this.props;
    const isHLBCampaignEnabled = !!(project && project.hlbCampaignIsEnabled);
    const isAgent = auth && auth.companyBranch && auth.companyBranch.isExternal;

    return isHLBCampaignEnabled && isAgent;
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    const { selected } = this.state;
    const { onConfirm } = this.props;

    if (onConfirm) {
      onConfirm(e, selected);
    }
  };
  handleOnOpen = () => {
    const { store } = this.context;
    store.dispatch(resetFlashMessage());
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  get tabs() {
    const { t } = this.props;
    return [
      { text: t('Panel', { ns: 'translation' }), name: 'panel_banker', value: 'panel_banker' },
      { text: t('Preferred', { ns: 'translation' }), name: 'preferred_banker', value: 'preferred_banker' },
      { text: t('All', { ns: 'translation' }), name: 'banker', value: 'banker' },
    ];
  }
  handleChangeTab = (e, { name, value }) => {
    const currentTab = name || value;
    this.setState({ currentTab, currentPage: 1 }, () => {
      this.fetchBankers();
    });
  }
  handleOnSelect = (e, banker) => {
    const { selected } = this.state;
    const index = selected.findIndex(b => b.id === banker.id);
    if (index < 0) {
      if (this.handleOnCheck(banker)) {
        return;
      }
      selected.push(banker);
    } else {
      selected.splice(index, 1);
    }
    this.setState({ selected }, () => {
      if (this.props.bankerOnSelect) {
        this.props.bankerOnSelect(banker);
      }
    });
  }
  handleOnCheck = (banker) => {
    if (this.props.bankerOnCheck) {
      const { selected } = this.state;
      return this.props.bankerOnCheck(banker, selected);
    }
    return false;
  }
  handleOnCheckSelected = (banker) => {
    if (this.props.bankerOnCheckSelected) {
      return this.props.bankerOnCheckSelected(banker);
    }
    return false;
  }
  handleClearFilter = () => {
    this.setState({ search: '' }, () => {
      this.fetchBankers();
    });
  }
  handleOnChange = (search) => {
    this.setState({ search }, () => {
      this.fetchBankers();
    });
  }
  handleChangePage = (currentPage) => {
    this.setState({ currentPage }, () => {
      this.fetchBankers();
    });
  }
  handleOpenHLBModal = () => {
    this.setState({ showHLBJoinModal: true });
  }
  handleCloseHLBModal = () => {
    this.setState({ showHLBJoinModal: false });
  }
  render() {
    const { t } = this.props;
    const hlbBankCodes = ['HLB', 'HLI'];
    return (
      <Modal
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="large"
        className="items-list-modal"
      >
        <Header
          icon="add"
          content={t('Add bankers', { ns: 'translation' })}
        />
        <Modal.Content>
          {
            !this.props.only && (!this.state.customTabs || (this.state.customTabs && this.state.customTabs.length < 1)) ? (
              <Menu widths={3} secondary pointing>
                {
                  this.tabs.map((tab, key) => (
                    <Menu.Item
                      key={key}
                      name={tab.name}
                      onClick={this.handleChangeTab}
                      active={this.state.currentTab === tab.name}
                    >{tab.text}</Menu.Item>
                  ))
                }
              </Menu>
            ) : null
          }
          {
            !this.props.only && this.state.customTabs && this.state.customTabs.length > 0 ? (
              <Menu widths={this.state.customTabs.length} secondary pointing>
                {
                  this.state.customTabs.map((tab, key) => (
                    <Menu.Item
                      key={key}
                      name={tab.name}
                      onClick={this.handleChangeTab}
                      active={this.state.currentTab === tab.name}
                    >{tab.text}</Menu.Item>
                  ))
                }
              </Menu>
            ) : null
          }
          <Grid verticalAlign="middle" columns={1}>
            <Grid.Column>
              <SearchFilter
                isLoading={this.state.loading}
                onChange={this.handleOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
              />
            </Grid.Column>
            <Grid.Column className="list">
              <Dimmer
                inverted style={{ zIndex: 20 }}
                active={this.state.loading && this.state.data.length > 0}
              >
                <Loader inline="centered">{t('Loading', { ns: 'translation' })}</Loader>
              </Dimmer>
              {
                this.state.data.length > 0 ? (
                  <Table className="hlb-table-banker-listing" unstackable>
                    <Table.Body>
                      {
                        this.state.data.map((d, idx) => {
                          let banker = d;
                          if (d && d.banker && d.statusID && d.statusID === '200') {
                            banker = d.banker;
                            banker.pendingOnboarding = true;
                          }
                          const isSelected = this.state.selected.some(s => s.id === banker.id);
                          const isHLBBankCampaign = banker.bank && hlbBankCodes.includes(banker.bank.code) && this.showHLBCampaign();
                          const disabled = this.handleOnCheck(banker);
                          return (
                            <Table.Row
                              key={idx}
                              active={disabled}
                              className={isHLBBankCampaign ? 'hlb-bank-row' : ''}
                            >
                              <Table.Cell>
                                <BankerItem
                                  banker={banker}
                                  onClick={this.handleOnSelect}
                                  selected={isSelected || this.handleOnCheckSelected(banker)}
                                  disabled={disabled}
                                  checkable
                                  isHLBCampaign={this.showHLBCampaign()}
                                  isHLBCampaignBank={isHLBBankCampaign}
                                />
                              </Table.Cell>
                            </Table.Row>
                          );
                        })
                      }
                    </Table.Body>
                  </Table>
                ) : (
                  <Segment textAlign="center">
                    {
                      this.state.loading ?
                        <Loader active inline="centered">{t('Loading', { ns: 'translation' })}</Loader>
                      : t(`No ${this.state.currentTab.replace('_', ' ')} found.`, { ns: 'translation' })
                    }
                  </Segment>
                )
              }
            </Grid.Column>
            {
              this.state.selected.some(s => hlbBankCodes.includes(s.bank.code)) && this.showHLBCampaign() ? (
                <Grid.Column>
                  <HLBEligibleBanner onJoinCampaign={this.handleOpenHLBModal} />
                </Grid.Column>
              ) : null
            }
            <Grid.Column textAlign="right">
              {this.props.extraNode}
              {
                this.props.limit && this.props.limit > 0 ? (
                  <LimitCounter
                    current={this.state.selected.length}
                    limit={this.props.limit}
                    primaryText={t('bankers', { ns: 'translation' })}
                    t={t}
                  />
                ) : null
              }
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <PageNav
            currentPage={this.state.currentPage}
            count={this.state.count}
            limit={this.state.limit}
            offset={this.state.offset}
            dataSize={this.state.data.length}
            loading={this.state.loading}
            onChange={this.handleChangePage}
            hideDropdown
          />
          <Button
            primary
            onClick={this.handleOnComfirm}
            icon="checkmark"
            content={t('Add', { ns: 'screens' })}
            disabled={this.state.selected.length < 1}
          />
        </Modal.Actions>
        <HLBCampaignJoinModal
          show={this.state.showHLBJoinModal}
          onClose={this.handleCloseHLBModal}
        />
      </Modal>
    );
  }
}

export default withRouter(connect(BankersList.mapStateToProps)(withTranslation()(BankersList)));



// WEBPACK FOOTER //
// ./src/containers/modals/BankersList.jsx